import api from './api';

export const pagingInfo = {
    page: 1, // 페이지
    limit: 10, // 한 목록에 표출되는 건수
    totalItems: '', // 총 Item 수
    itemCount: '', // 현재 페이지 item 수
    totalPages: '', // 총 페이지 수
    route: '', // 링크 경로 생성시 프리픽스
};

export const TICKET_TYPES = {
    P: '개인',
    O: 'OT',
    D: '듀엣',
    G: '그룹',
    C: '쿠폰',
    T: '회원권',
    S: '운동복'
};

export const TICKET_INFO = [
    { text: '개인', value: 'P' },
    { text: 'OT', value: 'O' },
    { text: '듀엣', value: 'D' },
    { text: '그룹', value: 'G' },
    { text: '쿠폰', value: 'C' },
    { text: '회원권', value: 'T' },
    { text: '운동복', value: 'S' }
]

export const NICEPAY_CARDS = {
    '01': '비씨',
    '02': 'KB국민',
    '03': '하나(외환)',
    '04': '삼성',
    '06': '신한',
    '07': '현대',
    '08': '롯데',
    '09': '한미',
    '10': '신세계한미',
    '11': '씨티',
    '12': 'NH채움',
    '13': '수협',
    '14': '신협',
    '15': '우리BC',
    '16': '하나',
    '17': '우리',
    '21': '광주',
    '22': '전북',
    '23': '제주',
    '24': '산은캐피탈',
    '25': '해외비자',
    '26': '해외마스터',
    '27': '해외다이너스',
    '28': '해외AMX',
    '29': '해외JCB',
    '31': 'SK-OK CASH-BAG',
    '32': '우체국',
    '33': '저축은행',
    '34': '은련',
    '35': '새마을금고',
    '36': 'KDB산업',
    '37': '카카오뱅크',
    '38': '케이뱅크',
    '39': 'PAYCO 포인트',
    '40': '카카오머니',
    '41': 'SSG머니',
    '42': '네이버포인트',
    '44': '토스뱅크',
}

export const BANK_TYPES = {
    '001': '한국은행',
    '002': '산업은행',
    '003': '기업은행',
    '004': '국민은행',
    '005': '외환은행',
    '007': '수협은행',
    '008': '수출입은행',
    '011': '농협은행',
    '012': '농협회원조합',
    '020': '우리은행',
    '023': 'SC제일은행',
    '026': '서울은행',
    '027': '한국씨티은행',
    '031': '대구은행',
    '032': '부산은행',
    '034': '광주은행',
    '035': '제주은행',
    '037': '전북은행',
    '039': '경남은행',
    '045': '새마을금고연합회',
    '048': '신협중앙회',
    '050': '상호저축은행',
    '051': '기타 외국계은행',
    '052': '모건스탠리은행',
    '054': 'HSBC은행',
    '055': '도이치은행',
    '056': '알비에스피엘씨은행',
    '057': '제이피모간체이스은행',
    '058': '미즈호코퍼레이트은행',
    '059': '미쓰비시도쿄UFJ은행',
    '060': 'BOA',
    '061': '비엔피파리바은행',
    '062': '중국공상은행',
    '063': '중국은행',
    '064': '산림조합',
    '065': '대화은행',
    '071': '우체국',
    '076': '신용보증기금',
    '077': '기술신용보증기금',
    '081': '하나은행',
    '088': '신한은행',
    '089': '케이뱅크',
    '090': '카카오뱅크',
    '092': '토스뱅크',
    '093': '한국주택금융공사',
    '094': '서울보증보험',
    '095': '경찰청',
    '099': '금융결제원',
    '209': '동양종합금융증권',
    '218': '현대증권',
    '230': '미래에셋증권',
    '238': '대우증권',
    '240': '삼성증권',
    '243': '한국투자증권',
    '247': 'NH투자증권',
    '261': '교보증권',
    '262': '하이투자증권',
    '263': '에이치엠씨투자증권',
    '264': '키움증권',
    '265': '이트레이드증권',
    '266': 'SK증권',
    '267': '대신증권',
    '268': '솔로몬투자증권',
    '269': '한화증권',
    '270': '하나대투증권',
    '278': '신한금융투자',
    '279': '동부증권',
    '280': '유진투자증권',
    '287': '메리츠증권',
    '289': '엔에이치투자증권',
    '290': '부국증권',
    '291': '신영증권',
    '292': '엘아이지투자증권',
}


export default {
    install(Vue, options) {
        // 페이징 정보


        // 업로드 파일 정보
        Vue.prototype.$uploadFile = {
            filename: null, // 파일명
            mimetype: null, // MimeType
            base64data: null, // Base64파일데이터
        };

        // 이메일 리스트
        Vue.prototype.$emailType = [
            'naver.com',
            'gmail.com',
            'daum.net',
            'nate.com',
            'hotmail.com',
            'outlook.kr',
            'yahoo.com',
            'korea.com',
        ];

        // 한 페이지에 표시되는 row count
        Vue.prototype.$sortType = [
            '10줄보기',
            '20줄보기',
            '50줄보기',
            '100줄보기',
        ];
        Vue.prototype.$sortTypeValue = [10, 20, 50, 100];

        // 기간 검색 리스트
        Vue.prototype.$periodTypeList = [
            '오늘',
            '어제',
            '이번 달',
            '지난 달',
            '3개월',
            '6개월',
            '12개월',
        ];
        Vue.prototype.$periodTypeValueList = [
            'today',
            'yesterday',
            'thisMonth',
            'prevMonth',
            '3M',
            '6M',
            '12M',
        ];

        // 시스템코드
        // object = { tableName: [...columnName] }
        Vue.prototype.$getSystemCode = async (object) => {
            const data = { tableName: [], columnName: [] };
            _.each(object, (columns, table) => {
                columns.forEach((column) => {
                    data.tableName.push(table);
                    data.columnName.push(column);
                });
            });
            // 스웨거 검색: 시스템코드 목록 조회
            const res = await api.post('/admin/api/systemCode/list', data);
            return res.data;
        };

        // $watch 내에서 재귀적으로 호출되지 않도록 함
        Vue.prototype.$withoutWatchers = function (cb) {
            const watchers = this._watchers.map((watcher) => ({
                cb: watcher.cb,
                sync: watcher.sync,
            }));

            for (const index in this._watchers) {
                this._watchers[index] = Object.assign(this._watchers[index], {
                    cb: () => null,
                    sync: true,
                });
            }

            cb();

            for (const index in this._watchers) {
                this._watchers[index] = Object.assign(
                    this._watchers[index],
                    watchers[index]
                );
            }
        };

        Vue.prototype.goTo = function (path) {
            this.$router.push({ path });
        };
    },
};

Number.prototype.toMoney = function () {
    return this ? String(this).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : '0';
};

// String.prototype.replaceAll = function (searchValue, replaceValue) {
//     return this ? String(this).replace(searchValue, replaceValue) : this;
// };

export const convertImgToDataURLviaCanvas = function(url, callback) {
    if (url == undefined || url == "" || url == null) {
        callback("", 0, 0);
        return;
    }

    var img = new Image();
    img.crossOrigin = 'anonymous';

    img.src = url + "?t=" + new Date().getTime();
    // img.src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABb8AAAAWCAYAAADgruFiAAACh0lEQVR4Xu3YQQ0AIBADQfDBE//O0AAJMjZzDjq9V+dZ+w5HgAABAgQIECBAgAABAgQIECBAgAABAgRCAtP4HWpTFAIECBAgQIAAAQIECBAgQIAAAQIECBD4AsZvj0CAAAECBAgQIECAAAECBAgQIECAAAECOQHjd65SgQgQIECAAAECBAgQIECAAAECBAgQIEDA+O0HCBAgQIAAAQIECBAgQIAAAQIECBAgQCAnYPzOVSoQAQIECBAgQIAAAQIECBAgQIAAAQIECBi//QABAgQIECBAgAABAgQIECBAgAABAgQI5ASM37lKBSJAgAABAgQIECBAgAABAgQIECBAgAAB47cfIECAAAECBAgQIECAAAECBAgQIECAAIGcgPE7V6lABAgQIECAAAECBAgQIECAAAECBAgQIGD89gMECBAgQIAAAQIECBAgQIAAAQIECBAgkBMwfucqFYgAAQIECBAgQIAAAQIECBAgQIAAAQIEjN9+gAABAgQIECBAgAABAgQIECBAgAABAgRyAsbvXKUCESBAgAABAgQIECBAgAABAgQIECBAgIDx2w8QIECAAAECBAgQIECAAAECBAgQIECAQE7A+J2rVCACBAgQIECAAAECBAgQIECAAAECBAgQMH77AQIECBAgQIAAAQIECBAgQIAAAQIECBDICRi/c5UKRIAAAQIECBAgQIAAAQIECBAgQIAAAQLGbz9AgAABAgQIECBAgAABAgQIECBAgAABAjkB43euUoEIECBAgAABAgQIECBAgAABAgQIECBAwPjtBwgQIECAAAECBAgQIECAAAECBAgQIEAgJ2D8zlUqEAECBAgQIECAAAECBAgQIECAAAECBAg80OMv34OCBPMAAAAASUVORK5CYII=";
    // img.src = "data:image/png;base64,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";

    img.onload = function() {
        var canvas = document.createElement('CANVAS');
        var ctx = canvas.getContext('2d');
        var dataURL;
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL();
        callback(dataURL, this.width, this.height);
        canvas = null;
    };
};
